
interface OpenRouterResponse {
    choices: {
        message: {
            content: string;
            role: string;
        };
    }[];
}

export class AIService {
    private apiKey: string;
    private baseUrl = "https://openrouter.ai/api/v1";

    constructor(apiKey?: string) {
        this.apiKey = apiKey || (typeof window !== "undefined" ? localStorage.getItem("moonrun_ai_api_key") || "" : "");
    }


    setApiKey(key: string) {
        this.apiKey = key;
        localStorage.setItem("moonrun_ai_api_key", key);
    }

    getApiKey() {
        return this.apiKey;
    }

    async chat(messages: { role: "user" | "assistant" | "system"; content: string }[]) {
        if (!this.apiKey) {
            throw new Error("API Key not configured");
        }

        try {
            const response = await fetch(`${this.baseUrl}/chat/completions`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${this.apiKey}`,
                    "Content-Type": "application/json",
                    "HTTP-Referer": window.location.origin,
                    "X-Title": "MoonRun",
                },
                body: JSON.stringify({
                    model: "openai/gpt-4o", // Defaulting to a high quality model
                    messages,
                }),
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error?.message || "Failed to fetch from OpenRouter");
            }

            const data = await response.json() as OpenRouterResponse;
            return data.choices[0].message.content;
        } catch (error) {
            console.error("AI Service Error:", error);
            throw error;
        }
    }
}

export const aiService = new AIService();
